import { useState } from 'react'
import PropTypes from 'prop-types'
import Toast from './Toast/Toast'

const StarRating = ({ maxStars = 5, value = 0, onChange, size = 'fs-4' }) => {
  const [hovered, setHovered] = useState(null)

  const handleClick = (index) => {
    Toast({ title: `¡Calificaste al talento con ${index + 1} estrellas!` })
    if (onChange) {
      onChange(index + 1)
    }
  }

  return (
    <div className={`d-flex gap-1 ${size}`}>
      {[...Array(maxStars)].map((_, index) => {
        const isFilled = hovered !== null ? index <= hovered : index < value
        return isFilled ? (
          <i
            key={index}
            className={`bi ${
              isFilled ? 'bi-star-fill' : 'bi-star'
            } text-warning cursor-pointer`}
            onClick={() => handleClick(index)}
            onMouseEnter={() => setHovered(index)}
            onMouseLeave={() => setHovered(null)}
            style={{ cursor: 'pointer' }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M11.8207 2.36333C11.894 2.21469 12.106 2.21469 12.1793 2.36333L15.0435 8.16582C15.0726 8.22479 15.1289 8.26568 15.1939 8.27519L21.5992 9.21142C21.7632 9.23539 21.8286 9.43696 21.7099 9.55259L17.0754 14.0666C17.0282 14.1126 17.0067 14.1788 17.0178 14.2437L18.1115 20.6205C18.1395 20.7839 17.968 20.9085 17.8213 20.8314L12.0931 17.819C12.0348 17.7883 11.9652 17.7883 11.9069 17.819L6.17873 20.8314C6.032 20.9085 5.86049 20.7839 5.88851 20.6205L6.98222 14.2437C6.99335 14.1788 6.97182 14.1125 6.92464 14.0666L2.29014 9.55259C2.17142 9.43696 2.23677 9.23539 2.40076 9.21142L8.80607 8.27519C8.87114 8.26568 8.92738 8.22479 8.95649 8.16582L11.8207 2.36333Z"
                fill="#FFB800"
                stroke="#FFB800"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </i>
        ) : (
          <i
            key={index}
            className={`bi ${
              isFilled ? 'bi-star-fill' : 'bi-star'
            } text-on-bg-primary cursor-pointer`}
            onClick={() => handleClick(index)}
            onMouseEnter={() => setHovered(index)}
            onMouseLeave={() => setHovered(null)}
            style={{ cursor: 'pointer' }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M11.8207 2.36333C11.894 2.21469 12.106 2.21469 12.1793 2.36333L15.0435 8.16582C15.0726 8.22479 15.1289 8.26568 15.1939 8.27519L21.5992 9.21142C21.7632 9.23539 21.8286 9.43696 21.7099 9.55259L17.0754 14.0666C17.0282 14.1126 17.0067 14.1788 17.0178 14.2437L18.1115 20.6205C18.1395 20.7839 17.968 20.9085 17.8213 20.8313L12.0931 17.819C12.0348 17.7883 11.9652 17.7883 11.9069 17.819L6.17873 20.8313C6.032 20.9085 5.86049 20.7839 5.88851 20.6205L6.98222 14.2437C6.99335 14.1788 6.97182 14.1126 6.92464 14.0666L2.29014 9.55259C2.17142 9.43696 2.23677 9.23539 2.40076 9.21142L8.80607 8.27519C8.87114 8.26568 8.92738 8.22479 8.95649 8.16582L11.8207 2.36333Z"
                stroke="#B5C9C9"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </i>
        )
      })}
    </div>
  )
}

StarRating.propTypes = {
  maxStars: PropTypes.number,
  value: PropTypes.number,
  onChange: PropTypes.func,
  size: PropTypes.string,
}

export default StarRating
